import { render, staticRenderFns } from "./ProdutividadeArea.vue?vue&type=template&id=64387186&scoped=true&"
import script from "./ProdutividadeArea.vue?vue&type=script&lang=js&"
export * from "./ProdutividadeArea.vue?vue&type=script&lang=js&"
import style0 from "./ProdutividadeArea.vue?vue&type=style&index=0&id=64387186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64387186",
  null
  
)

export default component.exports